import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getClassAccessGroups, getClassAccessGroup } from './session-access.api';

export const sessions = createQueryKeys('session-access', {
  list: (params: { locationId: number }) => ({
    queryKey: [params],
    queryFn: () => getClassAccessGroups(params.locationId),
  }),
  detail: (params: { locationId: number; id: number | undefined }) => ({
    queryKey: [params],
    queryFn: () => getClassAccessGroup(params.locationId, params.id),
  }),
});
